import { API, graphqlOperation } from "aws-amplify";
import { productByAccountByActiveByProductCode } from "../../../graphql/account/account-queries";

import { logError } from "../../../utils/appUtils";
import { VALIDATION_MSG } from "../../../utils/constants";
import { trimDecimal } from "../../../utils/utils";

// Available = on hand minus committed. Single source of truth for this calc.
export const getTotalQuantityAvailable = (record) =>
  trimDecimal(
    Number(record?.totalQuantityOnHand || 0) -
      Number(record?.totalQuantityCommitted || 0),
    3,
  );

// The low-inventory flag: available at or below the threshold. Goes through
// getTotalQuantityAvailable so every surface that writes the flag compares the
// same trimmed number and a float-summation residue can't flip it one way on
// one screen and the other way on the next. Keep in sync with
// resyncProductTotals in
// amplify/backend/function/handleInventoryChange/src/index.js.
export const computeLowInventoryAlert = (totals, lowInventoryThreshold) =>
  getTotalQuantityAvailable(totals) <= Number(lowInventoryThreshold || 0);

export const validateProductCodeUnicity = async (form, notify = false) => {
  const formState = form.getState();
  const allValues = formState.values;

  // if not dirty on edit, skip validation
  if (allValues?.id && !formState?.dirtyFields?.productCode) {
    return false; // no errors
  }

  try {
    const resp = await API.graphql(
      graphqlOperation(productByAccountByActiveByProductCode, {
        accountId: allValues.accountId,
        activeProductCode: {
          eq: { active: "true", productCode: allValues.productCode },
        },
      }),
    );

    debugger;
    if (resp.data.productByAccountByActiveByProductCode.items.length !== 0) {
      form.mutators.setFieldData("productCode", {
        error: "Must be unique",
      });
      return true; // has errors
    } else {
      form.mutators.setFieldData("productCode", {
        error: undefined,
      });
      return false; // no errors
    }
  } catch (error) {
    logError("products:ProductUtils:validateProductCodeUnicity", error, notify);
    if (notify) throw error;
  }
};

export const handleValidateSave =
  (form, setSaving, handleSave, notify) => async () => {
    const handleValidationFailure = () => {
      setSaving(false);
      notify(VALIDATION_MSG, "warning"); // needed on create
      handleSave(); // submit to force field-level validation errors
    };

    try {
      const formState = form.getState();
      const isValid = !formState.invalid;
      setSaving(true);

      if (!isValid) {
        handleValidationFailure();
        return;
      }

      const errors = await validateProductCodeUnicity(form, notify);
      if (errors) {
        handleValidationFailure();
        return;
      }

      handleSave(); // proceed with submit & form validation
    } catch (error) {
      setSaving(false);
    }
  };

// Ignore missing ProductStats rows. Some products may predate the new table.
// AppSync/DynamoDB conditional delete failures may be returned in different shapes.
export const isMissingProductStatsError = (error) => {
  const errors = error?.errors || error?.data?.errors;

  const message = JSON.stringify(
    errors && errors.length ? errors : error || "",
  ).toLowerCase();

  return (
    message.includes("not found") ||
    message.includes("notfound") ||
    message.includes("conditionalcheckfailed") ||
    message.includes("conditional check failed")
  );
};
